import { Icons } from '@nextiva/next-ui-components';
import {
  IBrandRegistrationConst,
  ICustomerConsentConst,
  IMessagingPlanConst,
  IMessageContentConst,
  ICustomerPromptsConst,
  IPrivacyPolicyConst,
  ICompanyTypeInfo,
  IRequestWebsiteFormConst,
  ICardContent,
} from 'interface/WizardV3';

export const AUTOM8TLY_KEY = 'autom8tlyUrl';
export const ENABLEMENT_INFO_KEY = 'enablementInfo';
export const CAMPAIGN_STATUS_KEY = 'campaignStatus';
export const SMS_CAMPAIGN_INFO_KEY = 'smsCampaignInformation';
export const STOCK_EXCHANGE_KEY = 'getStockExchanges';
export const FILE_ATTACHMENTS_KEY = 'getCampaignFileAttachments';
export const USER_INFO = 'userInfo';
export const PHONE_NUMBER_BY_CARRIER = 'PhoneNumberByCarrier';
export const PHONE_NUMBER_FOR_SOLE_PROPRIETOR = 'PhoneNumberForSoleProprietor';

export const SMS_CAMPAIGN_STATUS = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  PENDING: 'PENDING',
  NOT_STARTED: 'NOT_STARTED',
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  PENDING_BRAND_RETRY: 'PENDING_BRAND_RETRY',
  PENDING_DCA_COMPLETE: 'PENDING_DCA_COMPLETE',
  SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
};

export const BRAND_REGISTRATION_FIELDS: IBrandRegistrationConst = {
  COMPANY_TYPE: 'companyType',
  BUSINESS_TYPE: 'typeOfBusiness',
  TAX_ID: 'taxIdEin',
  TAX_ID_CONFIRM: 'taxIdEinConfirm',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MOBILE_PHONE_NUMBER: 'mobilePhoneNumber',
  EMAIL: 'email',
  COMPANY_LEGAL_NAME: 'companyLegalName',
  IS_SAME_AS_COMPANY_NAME: 'isSameAsCompanyName',
  BRAND_NAME: 'brandName',
  STOCK_SYMBOL: 'stockSymbol',
  STOCK_EXCHANGE: 'stockExchange',
  STREET: 'addressStreet',
  CITY: 'addressCity',
  STATE: 'addressState',
  COUNTRY: 'addressCountry',
  ZIP_CODE: 'addressZipCode',
  WEBSITE: 'webSite',
  BUSINESS_NUMBER: 'businessNumber',
  IS_SAME_AS_BUSINESS_NUMBER: 'isSameAsBusinessNumber',
  PHONE_NUMBER: 'phoneNumber',
  BUSINESS_EMAIL: 'businessEmail',
};

export const CUSTOMER_CONSENT_FIELDS: ICustomerConsentConst = {
  CUSTOMER_CONSENT: 'messageFlowDescription',
  CUSTOMER_CONSENT_FORM: 'customerConsentForm',
};

export const MESSAGING_PLAN_FIELDS: IMessagingPlanConst = {
  CAMPAIGN_DESCRIPTION: 'campaignDescription',
  NUMBER_OF_LINES: 'numberOfLines',
  MESSAGE_PLAN: 'messagePlan',
  SUB_USE_CASES: 'subUseCases',
  VALID_SUB_USECASE: 'validSubUsecase',
};

export const CUSTOMER_PROMPTS_FIELDS: ICustomerPromptsConst = {
  OPT_IN_MESSAGE: 'optinMessage',
  SUPPORT_MESSAGE: 'supportMessage',
  OPT_OUT_MESSAGE: 'optoutMessage',
};

export const MESSAGE_CONTENT_FIELDS: IMessageContentConst = {
  EMBEDDED_LINK: 'embeddedLink',
  EMBEDDED_PHONE: 'embeddedPhone',
  DIRECT_LENDING: 'directLending',
  AGE_GATED: 'ageGated',
  SAMPLE_MESSAGE_ONE: 'sampleMessageOne',
  SAMPLE_MESSAGE_TWO: 'sampleMessageTwo',
  SAMPLE_MESSAGE_THREE: 'sampleMessage3',
  SAMPLE_MESSAGE_FOUR: 'sampleMessage4',
  SAMPLE_MESSAGE_FIVE: 'sampleMessage5',
};

export const PRIVACY_POLICY_FIELDS: IPrivacyPolicyConst = {
  PRIVACY_POLICY_LINK: 'privacyPolicyLink',
  TERMS_CONDITION_LINK: 'termsAndConditionsLink',
  AFFILIATE_MARKETING: 'isConfirmedNotForAffiliateMarketing',
};

export const FIELD_NAMES = {
  companyType: 'Company Type',
  typeOfBusiness: 'Business Type',
  taxIdEin: 'Tax ID/EIN',
  firstName: 'First Name',
  lastName: 'Last Name',
  mobilePhoneNumber: 'Phone Number',
  email: 'Email Address',
  companyLegalName: 'Company Legal Name',
  isSameAsCompanyName: 'Same as company name',
  brandName: 'DBA or Brand Name',
  stockSymbol: 'Stock Symbol',
  stockExchange: 'Stock Exchange',
  addressStreet: 'Street Address',
  addressCity: 'City',
  addressState: 'State',
  addressCountry: 'Country',
  addressZipCode: 'ZIP code',
  webSite: 'Company Website',
  businessNumber: 'Business Contact Number',
  isSameAsBusinessNumber: 'Same as business number',
  phoneNumber: 'Support Phone Number',
  businessEmail: 'Business Email Address',
  messageFlowDescription: 'Explain Customer Consent',
  numberOfLines: 'Number of Phone Lines',
  messagePlan: 'Explain Topic',
  campaignDescription: 'Explain Usage',
  optinMessage: 'Opt-In Message',
  supportMessage: 'Support Message',
  optoutMessage: 'Opt-Out Message',
  embeddedLink: 'Embedded Links',
  embeddedPhone: 'Embedded Phone Number',
  directLending: 'Direct Lending',
  ageGated: 'Age-Gated Content',
  sampleMessageOne: 'Sample Message 1',
  sampleMessageTwo: 'Sample Message 2',
  sampleMessage3: 'Sample Message 3',
  sampleMessage4: 'Sample Message 4',
  sampleMessage5: 'Sample Message 5',
  privacyPolicyLink: 'Privacy Policy Link',
  termsAndConditionsLink: 'Terms and Conditions Link',
  isConfirmedNotForAffiliateMarketing: 'Affiliate Marketing',
  corpAcctNbr: 'Corporate Account',
  creationDate: 'Registration Creation Date',
  updateDate: 'Update Date',
};

export const FIELD_NAMES_CSV = {
  corpAcctNbr: {
    name: 'Corporate Account',
    index: 0,
  },
  companyType: {
    name: 'Company Type',
    index: 1,
  },
  typeOfBusiness: {
    name: 'Business Type',
    index: 2,
  },
  companyLegalName: {
    name: 'Company Legal Name',
    index: 3,
  },
  brandName: {
    name: 'DBA or Brand Name',
    index: 4,
  },
  isSameAsCompanyName: {
    name: 'Same as the company name',
    index: 5,
  },
  stockSymbol: {
    name: 'Stock Symbol',
    index: 6,
  },
  stockExchange: {
    name: 'Stock Exchange',
    index: 7,
  },
  addressStreet: {
    name: 'Street Address',
    index: 8,
  },
  addressCity: {
    name: 'City',
    index: 9,
  },
  addressState: {
    name: 'State',
    index: 10,
  },
  addressZipCode: {
    name: 'ZIP code',
    index: 11,
  },
  addressCountry: {
    name: 'Country',
    index: 12,
  },
  webSite: {
    name: 'Company Website',
    index: 13,
  },
  firstName: {
    name: 'First Name',
    index: 14,
  },
  lastName: {
    name: 'Last Name',
    index: 15,
  },
  mobilePhoneNumber: {
    name: 'Phone Number (for SP)',
    index: 16,
  },
  email: {
    name: 'Email Address',
    index: 17,
  },
  businessNumber: {
    name: 'Business Contact Number',
    index: 18,
  },
  phoneNumber: {
    name: 'Support Phone Number',
    index: 19,
  },
  isSameAsBusinessNumber: {
    name: 'Same as business number',
    index: 20,
  },
  businessEmail: {
    name: 'Business Email Address',
    index: 21,
  },
  messageFlowDescription: {
    name: 'Explain Customer Consent',
    index: 22,
  },
  numberOfLines: {
    name: 'Number of Phone Numbers',
    index: 23,
  },
  campaignDescription: {
    name: 'Explain Usage',
    index: 24,
  },
  useCase: {
    name: 'Text messaging activity use case',
    index: 25,
  },
  subUseCases: {
    name: 'Text messaging activity subuse case(s)',
    index: 26,
  },
  optinMessage: {
    name: 'Opt-In Message',
    index: 27,
  },
  optoutMessage: {
    name: 'Opt-Out Message',
    index: 28,
  },
  supportMessage: {
    name: 'Support Message',
    index: 29,
  },
  embeddedLink: {
    name: 'Embedded Links',
    index: 30,
  },
  embeddedPhone: {
    name: 'Embedded Phone Number',
    index: 31,
  },
  directLending: {
    name: 'Direct Lending',
    index: 32,
  },
  ageGated: {
    name: 'Age-Gated Content',
    index: 33,
  },
  sampleMessageOne: {
    name: 'Sample Message 1',
    index: 34,
  },
  sampleMessageTwo: {
    name: 'Sample Message 2',
    index: 35,
  },
  sampleMessage3: {
    name: 'Sample Message 3',
    index: 36,
  },
  sampleMessage4: {
    name: 'Sample Message 4',
    index: 37,
  },
  sampleMessage5: {
    name: 'Sample Message 5',
    index: 38,
  },
  privacyPolicyLink: {
    name: 'Privacy Policy Link',
    index: 39,
  },
  termsAndConditionsLink: {
    name: 'Terms and Conditions Link',
    index: 40,
  },
  isConfirmedNotForAffiliateMarketing: {
    name:
      'I confirm that business messaging will not be used for Affiliate Marketing',
    index: 41,
  },
  creationDate: {
    name: 'Registration Creation Date',
    index: 42,
  },
  updateDate: {
    name: 'Update Date',
    index: 43,
  },
};

export const STEPSLIST = [
  {
    id: 1,
    name: 'Brand registration',
    fields: Object.values(BRAND_REGISTRATION_FIELDS),
  },
  {
    id: 2,
    name: 'Customer consent',
    fields: Object.values(CUSTOMER_CONSENT_FIELDS),
  },
  {
    id: 3,
    name: 'Messaging plan',
    fields: Object.values(MESSAGING_PLAN_FIELDS),
  },
  {
    id: 4,
    name: 'Customer prompts',
    fields: Object.values(CUSTOMER_PROMPTS_FIELDS),
  },
  {
    id: 5,
    name: 'Message contents',
    fields: Object.values(MESSAGE_CONTENT_FIELDS),
  },
  {
    id: 6,
    name: 'Privacy policy',
    fields: Object.values(PRIVACY_POLICY_FIELDS),
  },
];
export const defaultValuesWizardV3 = {
  typeOfBusiness: null,
  mobilePhoneNumber: null,
  companyLegalName: null,
  isSameAsCompanyName: false,
  brandName: null,
  stockSymbol: null,
  stockExchange: null,
  addressStreet: null,
  addressCity: null,
  addressState: null,
  addressCountry: null,
  addressZipCode: null,
  webSite: null,
  businessNumber: null,
  businessEmail: null,
  messageFlowDescription: null,
  numberOfLines: null,
  campaignDescription: null,
  optinMessage: null,
  supportMessage: null,
  optoutMessage: null,
  embeddedLink: false,
  embeddedPhone: false,
  directLending: false,
  ageGated: false,
  sampleMessageOne: null,
  sampleMessageTwo: null,
  sampleMessage3: null,
  sampleMessage4: null,
  sampleMessage5: null,
  privacyPolicyLink: null,
  termsAndConditionsLink: null,
  isConfirmedNotForAffiliateMarketing: false,
};

export const TOTAL_STEPSLIST = Object.keys(STEPSLIST).length;

export const COMPANY_VALUE = {
  GOV: 'Government Company',
  NON_PROFIT: 'Non-Profit Organization',
  PRIVATE: 'Private Company',
  PUBLIC: 'Public Company',
  SOLE_PROPRIETOR: 'Sole Proprietor Business',
};

export const BUSINESS_TYPE_VALUE = {
  AGRICULTURE: 'Agriculture',
  CONSTRUCTION: 'Construction, Materials, and Trade Services',
  COMMUNICATION: 'Media and Communication',
  EDUCATION: 'Education',
  ENERGY: 'Energy and Utilities',
  ENTERTAINMENT: 'Entertainment',
  FINANCIAL: 'Financial Services',
  GAMBLING: 'Gambling and Lottery',
  GOVERNMENT: 'Government Services and Agencies',
  HEALTHCARE: 'Healthcare and Life Sciences',
  HOSPITALITY: 'Hospitality and Travel',
  HUMAN_RESOURCES: 'HR, Staffing or Recruitment',
  INSURANCE: 'Insurance',
  LEGAL: 'Legal',
  MANUFACTURING: 'Manufacturing',
  NGO: 'Non-profit Organization',
  POLITICAL: 'Political',
  POSTAL: 'Postal and Delivery',
  PROFESSIONAL: 'Professional Services',
  REAL_ESTATE: 'Real Estate',
  RETAIL: 'Retail and Consumer Products',
  TECHNOLOGY: 'Information Technology Services',
  TRANSPORTATION: 'Transportation or Logistics',
};

export const ITEM_HEIGHT = 36;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5,
      width: 250,
    },
  },
};

export const CompanyTypeInfo: ICompanyTypeInfo[] = [
  {
    title: 'Private Company',
    description:
      'Business owned by investors and not available for public trade.',
    icon: Icons.building,
    value: 'PRIVATE',
    required: 'Tax ID/EIN.',
  },
  {
    title: 'Public Company',
    description:
      'Businesses whose shares are traded publicly on stock exchanges.',
    icon: Icons.team,
    value: 'PUBLIC',
    required: 'Tax ID/EIN, Trade symbol, Business email.',
  },
  {
    title: 'Non-profit Organization',
    description:
      'Organization that doesn’t operate for the purpose of generating profit.',
    icon: Icons.url,
    value: 'NON_PROFIT',
    required: 'Tax ID/EIN.',
  },
  {
    title: 'Government Company',
    description:
      'Government affiliated organization that provides public services.',
    icon: Icons.briefcase,
    value: 'GOV',
    required: 'Tax ID/EIN.',
  },
  {
    title: 'Sole Proprietor Business',
    description: 'Unincorporated business owned and run by one individual.',
    icon: Icons.userShield,
    value: 'SOLE_PROPRIETOR',
    required: 'Owner’s email and phone number.',
  },
];

export const pendingInfo = {
  status: 'Pending approval',
  icon: Icons.clockLight,
};

export const pendingSPInfo = {
  status: 'Pending verification',
  icon: Icons.clockLight,
};

export const pendingPublicNoBrandVerified = {
  status: 'Brand verification pending',
  icon: Icons.clockLight,
};

export const pendingPublicNoEmailVerified = {
  status: 'Email verification pending',
  icon: Icons.clockLight,
};

export const incompletePublicEmailVerification = {
  status: 'Email verification not completed',
  icon: Icons.clockLight,
};

export const Public2FAResubmit = {
  label: 'Business email address',
  buttonText: 'Resend OTP link',
  variant: 'email',
  infoText: `Haven't received an email for Business Email
              verification? Check your email and resend below.`,
};

export const SP2FAResubmit = {
  label: 'Mobile phone number',
  buttonText: 'Resend OTP',
  variant: 'phone',
  infoText: `Haven't received a text message for Business Messaging
              verification? Check your phone number and resend below.`,
};

export const stateValues = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};
export const KEYS_EXCLUDED_CSV = [
  'isSameAsBillingAddress',
  'isDefaultStartKeyword',
  'isDefaultStopKeyword',
  'isDefaultHelpKeyword',
  'helpKeywords',
  'isSubmitted',
  'optinKeywords',
  'optoutKeywords',
  'requesterUuid',
  'subscriberOptin',
  'subscriberOptout',
  'subscriberHelp',
  'taxIdEin',
  'taxIdEinConfirm',
  'emailNotificationsEnabled',
  'emailWebsiteRequestSent',
  'validSubUsecase',
];

export const SUB_USE_CASES_CSV = {
  '2FA': '2FA',
  ACCOUNT_NOTIFICATION: 'Account Notification',
  CUSTOMER_CARE: 'Customer Care',
  DELIVERY_NOTIFICATION: 'Delivery Notification',
  FRAUD_ALERT: 'Fraud Alert Messaging',
  HIGHER_EDUCATION: 'Higher Education',
  MARKETING: 'Marketing',
  POLLING_VOTING: 'Polling and voting',
  PUBLIC_SERVICE_ANNOUNCEMENT: 'Public Service Announcement',
  SECURITY_ALERT: 'Security Alert',
  LOW_VOLUME: 'Low Volume',
};

export const MAX_SAMPLE_MESSAGES = 5;
export const DEFAULT_NUM_SAMPLE_MESSAGES = 2;
export const EMPTY_FIELD_VALUE = '';
export const FILE_MAX_SIZE = 10_048_576;

export const ALLOWED_MIME_TYPES_SUPPORTDOCS = [
  /* .bmp */ 'image/bmp',
  /* .docx  */ 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  /* .htm, html */ 'text/html',
  /* .jpg, .jpeg */ 'image/jpeg',
  /* .odt  */ 'application/vnd.oasis.opendocument.text',
  /* .pdf */ 'application/pdf',
  /* .png */ 'image/png',
  /* .raw */ 'image/x-panasonic-raw',
  /* .rtf */ 'application/rtf',
  /* .rtf */ 'application/x-rtf',
  /* .rtf */ 'text/richtext',
  /* .rtf */ 'text/rtf',
  /* .tiff */ 'image/tiff',
  /* .txt */ 'text/plain',
  /* .xml */ 'application/xml',
  /* .xml */ 'text/xml',
];

export const ALLOWED_MIME_TYPES_MMS = [
  /* .3ga */ 'audio/3gpp2',
  /* .3ga */ 'audio/3ga',
  /* .3gp */ 'audio/3gpp',
  /* .3gp */ 'video/3gpp',
  /* .amr */ 'audio/amr',
  /* .avi */ 'video/avi',
  /* .bmp */ 'image/bmp',
  /* .bz2 */ 'application/x-bzip2',
  /* .cal */ 'text/calendar',
  /* .css */ 'text/css',
  /* .csv */ 'text/csv',
  /* .dib */ 'image/dib',
  /* .flac */ 'audio/flac',
  /* .flv */ 'video/x-flv',
  /* .gif */ 'image/gif',
  /* .gz */ 'application/x-gzip',
  /* .ico */ 'image/x-icon',
  /* .ico */ 'image/vnd.microsoft.icon',
  /* .jpeg, .jpg */ 'image/jpeg',
  /* .js */ 'text/javascript',
  /* .json */ 'application/json',
  /* .m1a, .m2a */ 'audio/mpeg',
  /* .m1v */ 'video/mpeg',
  /* .m4a */ 'audio/aac',
  /* .m4a */ 'audio/x-m4a',
  /* .m4b, .m4p,.mp4 */ 'audio/mp4',
  /* .mp4r */ 'audio/x-m4r',
  /* .m4v */ 'video/x-m4v',
  /* .mov */ 'video/quicktime',
  /* .mp1 */ 'audio/MPA',
  /* .mp2 */ 'audio/x-mpeg',
  /* .mp2 */ 'video/x-mpeg',
  /* .mp3 */ 'audio/mpeg3',
  /* .mp3 */ 'audio/x-mpeg-3',
  /* .mp4 */ 'video/mp4',
  /* .mpa */ 'audio/mpeg',
  /* .mpeg, .mpg, .mpv */ 'video/mpeg',
  /* .oga  */ 'audio/ogg',
  /* .ogm */ 'video/x-ogm',
  /* .ogg, .ogv */ 'video/ogg',
  /* .ogx */ 'application/ogg',
  /* .pdf */ 'application/pdf',
  /* .pjpeg */ 'image/pjpeg',
  /* .png */ 'image/png',
  /* .qt */ 'video/quicktime',
  /* .rtf */ 'application/rtf',
  /* .rtf */ 'application/x-rtf',
  /* .rtf */ 'text/richtext',
  /* .rtf */ 'text/rtf',
  /* .smil */ 'application/smil',
  /* .spx */ 'audio/speex',
  /* .spx */ 'audio/x-speex',
  /* .svg */ 'image/svg+xml',
  /* .tar */ 'application/x-tar',
  /* .tif, .tiff */ 'image/tiff',
  /* .txt */ 'text/plain',
  /* .vcard, .vcf */ 'text/vcard',
  /* .wap */ 'text/vnd.wap.wml',
  /* .wav */ 'audio/wav',
  /* .wav */ 'audio/vnd.wav',
  /* .wav */ 'audio/x-wav',
  /* .webm */ 'video/webm',
  /* .webp */ 'image/webp',
  /* .wmv */ 'video/x-ms-wmv',
  /* .xml */ 'application/xml',
  /* .xml */ 'text/xml',
  /* .zip */ 'application/zip',
  /* .zip */ 'application/zip-compressed',
  /* .zip */ 'application/x-zip-compressed',
];

export const EMAIL_SERVICE_NAMES = [
  'ACCOUNT',
  'ADMIN',
  'ADVERTISING',
  'AFFILIATE',
  'ALERTS',
  'BILLING',
  'BUSINESS',
  'CAREERS',
  'CONTACT',
  'CUSTOMER',
  'CUSTOMERSERVICE',
  'DEVELOPMENT',
  'EMAIL',
  'ENQUIRY',
  'FEEDBACK',
  'HELPDESK',
  'FINANCE',
  'HELLO',
  'HELP',
  'HR',
  'INFO',
  'INFORMATION',
  'IT',
  'JOBS',
  'LEGAL',
  'MAIL',
  'MARKETING',
  'NOREPLY',
  'NEWSLETTER',
  'OPERATIONS',
  'SALES',
  'SERVICE',
  'SECURITY',
  'SUPPORT',
  'SOLUTIONS',
  'SUPPORT',
  'TEAM',
];

export const EMAIL_FREE_PROVIDERS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'aol.com',
  'outlook.com',
  'icloud.com',
  'protonmail.com',
  'zoho.com',
  'yandex.com',
  'mail.com',
  'gmx.com',
  'inbox.com',
  'fastmail.com',
  'tutanota.com',
  'hushmail.com',
  'lavabit.com',
  'runbox.com',
  'countermail.com',
  'scryptmail.com',
  'ctemplar.com',
  'posteo.de',
  'mailbox.org',
  'disroot.org',
  'riseup.net',
  'autistici.org',
  'company.com',
  'titan.com',
  'mail.ru',
  'tuta.io',
  'tutanota.de',
  'proton.me',
  'protonmail.ch',
  'yandex.ru',
  'brevo.com',
  'mailfence.com',
  'hubspot.com',
  'hubspotmail.com',
  'hubspotemail.com',
  'hubspotemail.net',
];

export const DESCRIPTION_MARGIN_STYLE = {
  margin: '0px 0px 24px 32px',
};

export const CHECKBOX_STYLE = {
  '&.Mui-disabled': {
    color: '#EAEBEF',
    '&.Mui-checked': {
      color: '#005FEC3D',
    },
  },
};

export const REQUEST_WEBSITE_FORM: IRequestWebsiteFormConst = {
  PACKAGE_SELECTED: 'packageSelected',
  SUBSCRIPTION_TYPE: 'subscriptionType',
  USER_EMAIL: 'userEmail',
  PHONE_NUMBER: 'phoneNumber',
};
export const SUBSCRIPTION_TYPE = {
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
};

export const cardContent: ICardContent[] = [
  {
    title: 'Basic',
    subtitle: 'For solo entrepreneurs',
    price: {
      monthly: '$15',
      yearly: '$10',
    },
    description: [
      'Single page website',
      'Custom domain (free for 1st year)',
      'Pre-integrated live chat',
    ],
    value: 'Basic',
  },
  {
    title: 'Pro',
    subtitle: 'For small teams',
    price: {
      monthly: '$30',
      yearly: '$20',
    },
    description: [
      'Everything in basic + Up to 10 pages',
      'Basic e-commerce',
      'Sell services/memberships',
      'Accept donations',
    ],
    value: 'Pro',
  },
  {
    title: 'Elite',
    subtitle: 'For larger businesses',
    price: {
      monthly: '$50',
      yearly: '$40',
    },
    description: [
      'Everything in pro + Up to 1,000 pages',
      'Advanced e-commerce',
      'Sell digital & subscription based products',
      'Multi-language',
    ],
    value: 'Elite',
  },
];
